import { ICommunicationError } from "@dev/hc-talk-talk";
import AuthorizeConsentRequest from "@/app/dto/AuthorizeConsentRequest";
import CheckConsentRequest from "@/app/dto/CheckConsentRequest";
import IConsentResponse from "@/app/dto/IConsentResponse";
import ApiError from "@/app/model/ApiError";
import Api from "@/app/service/api";

class Consent {
    public check(clientId?: string, responseType?: string, redirectUri?: string): Promise<IConsentResponse> {
        return new Promise((resolve, reject) => {
            Api.checkConsent(new CheckConsentRequest(clientId, responseType, redirectUri))
                .then((response: any) => {
                    resolve(response);
                })
                .catch((error: ICommunicationError) => {
                    reject(new ApiError(error));
                });
        });
    }

    public authorize(token: string, clientId: string, responseType: string, consented: boolean, redirectUri: string): Promise<IConsentResponse> {
        return new Promise((resolve, reject) => {
            let uri = redirectUri == "" ? undefined : redirectUri;
            Api.authorizeConsent(token, new AuthorizeConsentRequest(clientId, responseType, consented, uri))
                .then((response: any) => {
                    resolve(response);
                })
                .catch((error: ICommunicationError) => {
                    reject(new ApiError(error));
                });
        });
    }
}

export default new Consent();
